// SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
// Copyright (C) 2023-2025 (original work) Open Assessment Technologies SA ;
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
import config from '@/config';
import { multiGuard } from '@/core/guards/guardComposer.js';
import { getFeaturesGuard } from '@/core/guards/featureFlagGuard.js';
import { getPermissionsGuard } from '@/core/guards/permissionsGuard.js';
import { FEATURE_CUSTOM_REPORTS } from '@/constants/features.js';

export const routing = [
    {
        path: [config.routes.reports.widgetSandbox],
        controller: () => import('./controllers/widgetSandbox'),
        guard: getFeaturesGuard(FEATURE_CUSTOM_REPORTS)
    },
    {
        path: [config.routes.reports.customReports],
        controller: () => import('./controllers/customReports'),
        guard: multiGuard([
            getFeaturesGuard(FEATURE_CUSTOM_REPORTS),
            getPermissionsGuard([{ resource: 'portal.custom-reports', scopes: ['view'] }])
        ])
    },
    {
        path: [config.routes.reports.report],
        controller: () => import('./controllers/report'),
        guard: getPermissionsGuard([
            { resource: 'portal.report', scopes: ['view'] },
            { resource: 'portal.session-report', scopes: ['view'] },
            { resource: 'portal.dashboard', scopes: ['view'] }
        ])
    }
];
